import type { ContextType, ReactNode } from "react";
import { useEffect, useState } from "react";
import { isMobile } from "~/kernel/browser/isMobile";
import { PWAInstallationContext } from "./PWAInstallationContext";

type Props = {
  children: ReactNode;
  waitForEvent: Promise<Event>;
};

export function PWAInstallationProvider({ children, waitForEvent }: Props) {
  const [value, setValue] = useState<
    ContextType<typeof PWAInstallationContext>
  >({
    showPrompt: false,
    installer: null,
  });

  useEffect(() => {
    waitForEvent
      .then((event) => {
        if (!isMobile()) {
          return;
        }

        if (isInstallableEvent(event)) {
          return setValue({
            showPrompt: true,
            installer: event,
          });
        }

        setValue({ installer: null, showPrompt: true });
      })
      .catch(() => {
        /* all good */
      });
  }, [waitForEvent]);

  return (
    <PWAInstallationContext.Provider value={value}>
      {children}
    </PWAInstallationContext.Provider>
  );
}

function isInstallableEvent(event: unknown): event is { prompt: () => void } {
  return (
    typeof event === "object" &&
    event !== null &&
    "prompt" in event &&
    typeof event.prompt === "function"
  );
}
